import { Icon } from "@iconify/react";
import React, { useState } from "react";

import { baseURL } from "../../config";
import { printFullDate } from "../../utils/time";
import { Link } from "react-router-dom";
// import Button from "./Button";
import { description as formatDescription, printUnit } from "../../utils/ar";
import Button from "./Button";
import LoadingIcon from "./LoadingIcon";
import { getYearPlaceHolder } from "../../services/yearSevices";
import { useLanguage } from "../../context/LanguageContext";

const courseCardContent = {
    upgradeOpportunity: {
        en: "Exclusive opportunity for you as a subscriber!",
        ar: "لديك فرصة مميزة لإنك مشترك بهذه الدورة!!",
        de: "Exklusive Gelegenheit für Sie als Abonnent!",
    },
    getCourse: {
        en: "Get this course:",
        ar: "أحصل علي دورة:",
        de: "Erhalten Sie diesen Kurs:",
    },
    priceOnly: {
        en: "For only:",
        ar: "بسعر:",
        de: "Nur für:",
    },
    takeChanceNow: {
        en: "Grab your chance now",
        ar: "أحصد فرصتك الآن",
        de: "Nutzen Sie Ihre Chance jetzt",
    },
    upgradeFrom: {
        en: "You can upgrade from your current subscription:",
        ar: "يمكنك الترقية من اشتراكك الحالي بدورة:",
        de: "Sie können Ihr aktuelles Abonnement upgraden:",
    },
    andGetThisCourse: {
        en: "and get this course",
        ar: "والحصول علي تلك الدورة",
        de: "und erhalten Sie diesen Kurs",
    },
    takeThisOffer: {
        en: "I will take this offer",
        ar: "سأستفيد من هذا العرض",
        de: "Ich nutze dieses Angebot",
    },
    courseNamePlaceholder: {
        en: "First Course - Test",
        ar: "الدورة الاول - تيست",
        de: "Erster Kurs - Test",
    },
    courseDescriptionPlaceholder: {
        en: "All contents of the first course",
        ar: "جميع محتويات الدورة الاول",
        de: "Alle Inhalte des ersten Kurses",
    },
    loadingCourse: {
        en: "Loading Course...",
        ar: "تحميل الدورة...",
        de: "Laden des Kurses...",
    },
    enrolledAlready: {
        en: "You are already enrolled in this course",
        ar: "انت مشترك في هذه الدورة",
        de: "Sie sind bereits für diesen Kurs eingeschrieben",
    },
    enrollNow: {
        en: "Enroll Now",
        ar: "اشترك الآن",
        de: "Einschreiben",
    },
    freeCourse: {
        en: "Free Course!",
        ar: "دورة مجانية!",
        de: "Kostenloser Kurs!",
    },
    checkLecture: {
        en: "Check the lecture",
        ar: "الاضطلاع علي المحاضرة",
        de: "Überprüfen Sie die Vorlesung",
    },
    accessCourse: {
        en: "Access Course",
        ar: "الدخول للدورة",
        de: "Kurs betreten",
    },
    subscribeNow: {
        en: "Subscribe Now",
        ar: "اشترك الآن",
        de: "Jetzt abonnieren",
    },
    coursePrice: {
        en: "Course Price:",
        ar: "سعر الدورة:",
        de: "Kursgebühr:",
    },
};

const UpgradableCourse = ({
    upgradable_course_name,
    upgradable_course_price,
    upgradable_course_id,
}) => {
    return (
        <div className="bg-yellow-100 shadow-lg dark:bg-green-100 text-black smooth rounded-md p-4">
            <div className="bg-gradient-to-r from-royalBlue-600 to-royalBlue-800 text-white rounded-md p-4">
                <div className="font-w-bold">لديك فرصة مميزة لإنك مشترك بهذه الدورة!!</div>
                <div>أحصل علي دورة:</div>
                <div className="font-w-bold">{upgradable_course_name}</div>
            </div>
            <div className="flex-center-both gap-2">
                <span>بسعر:</span>
                <div className="text-lg font-w-bold">
                    {printUnit(upgradable_course_price, "دينار")} فقط!{" "}
                </div>
            </div>
            <Link
                to={`/course/${upgradable_course_id}`}
                className="mt-2 inline-block mx-auto w-full text-center text-bold bg-green-300 font-w-bold text-royalBlue-900 px-4 py-2 rounded-md"
            >
                أحصد فرصتك الآن
            </Link>
        </div>
    );
};

const RelatedCourse = ({
    upgradable_from_course_name,
    upgradable_from_course_price,
    upgradable_from_course_id,
    course_id,
}) => {
    return (
        <div className="flex-center-both flex-col space-y-1 shadow-md py-2 px-3">
            <div className="bg-gradient-to-r text-center from-yellow-400 to-yellow-200 text-black rounded-md p-4">
                <div className="font-w-bold">يمكنك الترقية من اشتراكك الحالي بدورة:</div>
                <div className="font-w-bold">{upgradable_from_course_name}</div>
                والحصول علي تلك الدورة
            </div>
            <div className="flex-center-both gap-2">
                <span>بسعر:</span>
                <div className="text-lg font-w-bold">
                    {printUnit(upgradable_from_course_price, "دينار")} فقط!{" "}
                </div>
            </div>
            <Link
                to={`course/${course_id}/subscribe/related_subscription/${upgradable_from_course_id}`}
                className="mt-2 inline-block mx-auto w-3/4 text-center text-bold bg-rose-500 font-w-bold text-royalBlue-100 px-4 py-4 rounded-md"
            >
                سأستفيد من هذا العرض
            </Link>
        </div>
    );
};

const CourseCard = ({
    name = "الدورة الاول - تيست",
    description = "جميع محتويات الدورة الاول",
    price = "30",
    isNew = false,
    picture,
    isStaticPicture = false,
    updated_at,
    created_at,
    subscriptions_count = 0,
    isYear = false,
    id,
    isPrepaid = false,
    onPrepaidClick = null,
    teacher = null,
    upgradable_course_name,
    upgradable_course_price,
    upgradable_course_id,
    upgradable_from_course_name,
    upgradable_from_course_price,
    upgradable_from_course_id,
    has_course_to_course_relation,
    user_is_subscribed_to_upgradable_course,
    subject = null,
    ...props
}) => {
    const { language } = useLanguage();
    const [isLoading, setIsLoading] = useState(true);
    return (
        <div className="max-w-[380px] bg-gray-100 group flex flex-col items-center   min-h-[400px] py-6 px-3 rounded-[22px] shadow-md smooth">
            {/* {teacher ? (
                <div className="z-10 relative px-5 flex-center-both translate-y-1/3">
                    <div className="w-ful px-5 bg-primary-container smooth clr-text-primary rounded-md py-2 shadow-md border border-cyan-500 text-center">
                        <div className="font-w-bold">{teacher.name}</div>
                    </div>
                </div>
            ) : (
                ""
            )} */}
            <div className="overflow-hidden max-w-[320px]">
                <div className="p-2 flex-center-both smooth  group-hover:scale-110 group-hover:brightness-110">
                    <img
                        src={isStaticPicture ? isStaticPicture : `${baseURL}/${picture}`}
                        alt="course"
                        style={{ aspectRatio: "2 / 1" }}
                        onLoad={() => {
                            setIsLoading(false);
                        }}
                        className={` ${
                            isLoading ? "hidden " : undefined
                        } w-full max-w-[300px] min-h-[240px] rounded-[44px] object-contain transform text-center smooth`}
                    />
                    {isLoading ? (
                        <div className="h-72  min-w-[300px] rounded-[44px] bg-germanRed-50 smooth flex-center-both font-h1 font-w-bold smooth">
                            <div className="flex flex-row space-x-3 space-x-reverse">
                                <LoadingIcon className={"font-big text-blue-500"} />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            <div className="relative z-10 ">
                {isYear && (
                    <Link to={`/years/${isYear}`}>
                        <div
                            className={`rounded-md w-full bg-third-container clr-text-primary px-4 py-6 shadow-large--oblique hover-shadow-larg group-hover:shadow-large smooth ${
                                subscriptions_count < 1
                                    ? "border border-slate-300 dark:border-slate-800"
                                    : "border-2 border-cyan-500"
                            }`}
                        >
                            <div className="flex flex-col space-y-6">
                                <div className="flex flex-row flex-center-y justify-between space-x-4 space-x-reverse">
                                    <div className="flex flex-col space-y-4 w-full">
                                        <div className="font-w-bold font-h3 pr-3">{name}</div>
                                        <div
                                            className={`divider-2 rounded-lg smooth ${
                                                subscriptions_count < 1
                                                    ? "bg-germanRed-400 dark:bg-germanRed-600"
                                                    : "bg-cyan-500"
                                            }`}
                                        ></div>
                                        <div className="clr-text-secondary">
                                            {formatDescription(description)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                )}
                {!isYear && (
                    <div className={`rounded-md  w-full clr-text-primary py-6 smooth`}>
                        <div className="flex flex-col space-y-6">
                            {subject ? (
                                <div className="flex-center-both">
                                    <div className="font-w-bold rounded-md bg-yellow-500 bg-opacity-50 px-4 py-1">
                                        {subject.name} -{" "}
                                        <span className="underline">
                                            {getYearPlaceHolder(subject.year)}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}

                            <div className=" -mt-14 bg-white/20 backdrop-blur-md shadow-md w-full flex flex-col smooth space-y-2 px-3 py-5 rounded-md">
                                <div className="flex justify-between items-center flex-col space-y-4 ">
                                    <div className="flex flex-col space-y-4 w-full">
                                        <div className="font-w-bold font-h3 mx-auto text-germanAccentText smooth pr-3">
                                            {name}
                                        </div>
                                        {/* <div
                                        className={`divider-2 rounded-lg smooth ${
                                            subscriptions_count < 1
                                                ? "bg-germanRed-400 dark:bg-germanRed-600"
                                                : "bg-cyan-500"
                                        }`}
                                    ></div> */}
                                    </div>
                                </div>
                                <div className="clr-text-secondary text-center">
                                    {formatDescription(description, true)}
                                </div>
                                <div className="font-smaller shrink-0 flex flex-row justify-between gap-3">
                                    {subscriptions_count < 1 ? (
                                        <>
                                            {isPrepaid ? (
                                                // <Button className="bg-gradient-to-r from-germanRed-500 to-sky-500 clr-white rounded-md px-3 py-1 flex-center-both">
                                                //     اشترك الآن !
                                                // </Button>
                                                <Link
                                                    to={`/course/${id}`}
                                                    className="border-2 border-germanRed-500 rounded-md px-3 py-1 hover:bg-germanRed-500 hover:text-white  smooth clr-text-primary"
                                                >
                                                    {courseCardContent.checkLecture[language]}
                                                </Link>
                                            ) : (
                                                <>
                                                    {!upgradable_from_course_id ? (
                                                        <Link
                                                            to={`/course/${id}`}
                                                            className="border-2 border-yellow-500  rounded-md px-3 py-1 flex-center-both hover:bg-yellow-500  text-[16px]  smooth clr-text-primary"
                                                        >
                                                            {" "}
                                                            {
                                                                courseCardContent.accessCourse[
                                                                    language
                                                                ]
                                                            }
                                                        </Link>
                                                    ) : (
                                                        <div className=" flex-center-both flex-col space-y-4 ">
                                                            <RelatedCourse
                                                                upgradable_from_course_name={
                                                                    upgradable_from_course_name
                                                                }
                                                                upgradable_from_course_price={
                                                                    upgradable_from_course_price
                                                                }
                                                                upgradable_from_course_id={
                                                                    upgradable_from_course_id
                                                                }
                                                                course_id={id}
                                                            />
                                                            <Link
                                                                to={`/course/${id}`}
                                                                className="border-2 w-full border-yellow-500  rounded-md px-3 py-1 flex-center-both hover:bg-yellow-500 text-[16px]  smooth clr-text-primary"
                                                            >
                                                                {" "}
                                                                {
                                                                    courseCardContent.accessCourse[
                                                                        language
                                                                    ]
                                                                }
                                                            </Link>
                                                        </div>
                                                    )}

                                                    {price == 0 ? (
                                                        <div className="bg-gradient-to-r from-rose-500 to-purple-500 clr-white rounded-md px-3  flex-center-both">
                                                            {courseCardContent.freeCourse[language]}
                                                        </div>
                                                    ) : (
                                                        !upgradable_from_course_id && (
                                                            <Link
                                                                to={`/course/${id}/subscribe/previous_invoices/`}
                                                                className="relative inline-flex items-center justify-center font-semibold text-white rounded-md px-6 py-2  shadow-md bg-germanRed-500 smooth hover:bg-alphaOrange-500"
                                                            >
                                                                <span className="relative z-10">
                                                                    {
                                                                        courseCardContent.enrollNow[
                                                                            language
                                                                        ]
                                                                    }
                                                                </span>
                                                            </Link>
                                                        )
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : !upgradable_course_id ? (
                                        <div className="bg-cyan-500 bg-opacity-10 border-cyan-500 border rounded-md py-4 px-3 font-w-bold text-cyan-500 text-center">
                                            {courseCardContent.enrolledAlready[language]}
                                        </div>
                                    ) : (
                                        <UpgradableCourse
                                            upgradable_course_name={upgradable_course_name}
                                            upgradable_course_price={upgradable_course_price}
                                            upgradable_course_id={upgradable_course_id}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="flex relative flex-col items-center w-full mt-6 space-y-4">
                                {/* Divider */}
                                <div className="w-full pt-5 pb-5">
                                    <div className="h-[1px] bg-gray-300 dark:bg-alphaAccentText/50 smooth"></div>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex flex-col absolute sm:flex-row bottom-[.5px] items-center justify-center sm:justify-between space-y-4 sm:space-y-0 sm:space-x-4 w-full">
                                    {/* If not subscribed */}
                                    {subscriptions_count < 1 ? (
                                        <>
                                            {isPrepaid ? (
                                                // Prepaid Button
                                                <Button
                                                    onClick={() => onPrepaidClick(id, name)}
                                                    className="flex items-center mx-auto justify-center w-full sm:w-auto bg-germanRed-500 border-none text-white py-2 px-4 rounded-md hover:bg-germanRed-600 smooth "
                                                >
                                                    <Icon
                                                        icon="mdi:cart-check"
                                                        className="inline-block mr-2 text-lg"
                                                    />
                                                    {courseCardContent.subscribeNow[language]}
                                                </Button>
                                            ) : price == 0 ? (
                                                // Free Course
                                                <div className="flex items-center mx-auto justify-center w-full sm:w-auto bg-gradient-to-r from-rose-500 to-purple-500 text-white py-2 px-4 rounded-md ">
                                                    <Icon
                                                        icon="mdi:gift-outline"
                                                        className="inline-block ml-2 text-lg"
                                                    />
                                                    {courseCardContent.freeCourse[language]}
                                                </div>
                                            ) : (
                                                // Paid Course
                                                <div className="flex justify-center w-full items-center mt-4">
                                                    <div className="bg-gradient-to-r from-gray-400/80  to-gray-700/80 text-white font-bold py-2 px-4 rounded-md  text-center">
                                                        <span>
                                                            {language !== "ar" ? (
                                                                <span>{price} EGP</span>
                                                            ) : (
                                                                printUnit(price, "جنيه")
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        // Subscribed
                                        <Link
                                            to={`/course/${id}`}
                                            className="flex items-center justify-center w-full sm:w-auto bg-yellow-400 text-black py-2 px-4 rounded-md hover:bg-yellow-500 smooth "
                                        >
                                            <Icon
                                                icon="mdi:book-open-page-variant"
                                                className="inline-block mr-2 text-lg"
                                            />
                                            {courseCardContent.accessCourse[language]}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CourseCard;
